import { accessGroup as accessGroupConfig } from 'shared/api/query/configs.json';
import { accessPolicyType } from 'shared/constants.json';
import { dn } from '@/nebula/denormalize';

export const accessGroupsLoggedInUser = () => Object.values(dn.value[accessGroupConfig.model]).filter((ag) => {
  // We use only access policy type "read" to determine the "member" (all users) access group
  if (ag.accessPolicy.accountAccess === accessPolicyType.read) {
    return true;
  }

  return ag.accessPolicy.scopes.some((s) => s.userIsInScope === true);
});

// TODO: Can be removed if ComponentList.vue, duplicate.js and delete-goal.js can use setup function
export const loggedInUser = (state) => {
  if (state.loggedInUserId === 0) {
    return {};
  }

  return dn.value.user[state.loggedInUserId];
};

export const loggedInUserAccount = (_, getters) => {
  if (Object.keys(getters.loggedInUser).length === 0) {
    return {};
  }

  return dn.value.account[getters.loggedInUser.account.uid];
};

export const resolvedTenantId = (state) => state.currentTenant?.accountId ?? null;

export const foreignLogin = (state) => state.me?.foreignLogin === true;
